import { ITherapySuppliersResult } from 'API/Suppliers/suppliers';
import { ISuppliers, ITherapyFilters } from 'Context/SuppliersContext';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';

export interface IAction {
  type: string;
  payload: any;
}

export function SuppliersReducer(state: ISuppliers, action: IAction) {
  switch (action.type) {
    case SUPPLIER_RESULT_FILTER.Init: {
      const results = action.payload;
      const filteredResults = action.payload;
      return { ...state, results, filteredResults };
    }
    case SUPPLIER_RESULT_FILTER.Therapy: {
      const filteredResults = TherapyFilter(
        state.results,
        action.payload.value
      );
      //console.log(filteredResults);
      return { ...state, filteredResults };
    }
    default:
      return state;
  }
}

/**
 * Returns a filtered therapy suppliers array according to a given filler object.
 * Algorithm Example: [x,y,z,w] -> filter1: [x,y,z] -> filter2: [z,y] and etc.
 * @param data Therapy Suppliers Total Results Array
 * @param filters Filter Object Edited by the User
 */
function TherapyFilter(
  data: ITherapySuppliersResult[],
  filters: ITherapyFilters
) {
  const {
    supName,
    specialty,
    subSpecial,
    area,
    region,
    city,
    accessible,
    lng,
    gender,
    treatMethod,
    degree,
    homeVisit,
    institute,
    orderByAscendingAlphabet,
    orderByDescendingAlphabet,
  } = filters;

  const filterByName = supName
    ? data.filter(
        (therapyItem: ITherapySuppliersResult) => therapyItem.name === supName
      )
    : data;

  const filterBySpecialty = specialty
    ? filterByName.filter(
        (therapyItem: ITherapySuppliersResult) =>
          therapyItem.proffessions[0] === specialty
      )
    : filterByName;

  const filterBySubSpecialties = subSpecial
    ? filterBySpecialty.filter((therapyItem: ITherapySuppliersResult) =>
        therapyItem.specialties.includes(subSpecial)
      )
    : filterBySpecialty;

  //TODO Define if to check area or areas[]
  const filterByArea = area
    ? filterBySubSpecialties.filter((therapyItem: ITherapySuppliersResult) =>
        therapyItem.areas.includes(area)
      )
    : filterBySubSpecialties;

  const filterByRegion = region
    ? filterByArea.filter((therapyItem: ITherapySuppliersResult) =>
        therapyItem.regions.includes(region)
      )
    : filterByArea;

  const filterByCity = city
    ? filterByRegion.filter(
        (therapyItem: ITherapySuppliersResult) =>
          (therapyItem.firstCityId && therapyItem.firstCityId === city) ||
          (therapyItem.secondCityId && therapyItem.secondCityId === city)
      )
    : filterByRegion;

  const filterByAccessible = accessible
    ? filterByCity.filter(
        (therapyItem: ITherapySuppliersResult) =>
          therapyItem.hasAccessibilityForHandicapped
      )
    : filterByCity;

  const filterByLanguages =
    lng && lng.length > 0
      ? filterByAccessible.filter((therapyItem: ITherapySuppliersResult) =>
          therapyItem.languages.some((languageId: number) =>
            lng.includes(languageId)
          )
        )
      : filterByAccessible;

  const filterByGender = gender
    ? filterByLanguages.filter(
        (therapyItem: ITherapySuppliersResult) => therapyItem.gender === gender
      )
    : filterByLanguages;

  const filterByTreatMethods =
    treatMethod && treatMethod.length > 0
      ? filterByGender.filter((therapyItem: ITherapySuppliersResult) =>
          therapyItem.treatmentMethods.some((treatMethodId: number) =>
            treatMethod.includes(treatMethodId)
          )
        )
      : filterByGender;

  //TODO Academic Degree could be undefined for some, what to do ?
  //TODO There is Degree and AcademicDegreeId
  const filterByDegree =
    degree && degree.length > 0
      ? filterByTreatMethods.filter((therapyItem: ITherapySuppliersResult) =>
          therapyItem.academicDegreeId
            ? degree.includes(therapyItem.academicDegreeId)
            : false
        )
      : filterByTreatMethods;

  const filterByHomeVisit = homeVisit
    ? filterByDegree.filter(
        (therapyItem: ITherapySuppliersResult) => therapyItem.hasHomeVisit
      )
    : filterByDegree;

  const filterByInstitute = institute
    ? filterByHomeVisit.filter(
        (therapyItem: ITherapySuppliersResult) => therapyItem.isByInstitute
      )
    : filterByHomeVisit;

  const filteredTherapy = [...filterByInstitute];

  if (orderByAscendingAlphabet)
    filteredTherapy.sort((a: any, b: any) => a.name.localeCompare(b.name));
  if (orderByDescendingAlphabet)
    filteredTherapy.sort((a: any, b: any) => b.name.localeCompare(a.name));

  return filteredTherapy;
}
